module.exports = __webpack_public_path__ + "static/media/Group 2-2.0796d2fd.svg";